import { api } from "../../api/client";

export const adaiApi = {
  generateDocument: (payload) => api.post("/v1/docs/generate", payload),
  getJobStatus:     (jobId)   => api.get(`/v1/docs/jobs/${jobId}`),
  listJobs: ({ engagementId, search, sortOrder, status, page = 1, pageSize = 10 } = {}) => {
    const params = { engagement_id: engagementId, page, page_size: pageSize };
    if (search)    params.search     = search;
    if (sortOrder) params.sort_order = sortOrder;
    if (status)    params.status     = status;
    return api.get("/v1/docs/jobs", { params });
  },
};
